/* Oxa - Concept layer behaviours. No dependencies.
   Every feature binds to data attributes and is safe to run twice (the theme
   editor re-renders sections, so init() is called again per section). */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  root.classList.add('lc-js');

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function once(el, key) { if (!el || el['__lc_' + key]) return false; el['__lc_' + key] = true; return true; }
  function money(cents) {
    var fmt = (window.LC && LC.moneyFormat) || 'R {{amount}}';
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    var amount = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + v[1];
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }
  function esc(s) { var d = doc.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function lockScroll(on) { root.style.overflow = on ? 'hidden' : ''; }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Top bar messages ---------------- */
  function initTopbar(scope) {
    $$('[data-lc-top]', scope).forEach(function (bar) {
      if (!once(bar, 'top')) return;
      var msgs = $$('.lc-top__msg', bar);
      if (msgs.length < 2) return;
      var i = 0, timer = null, delay = parseInt(bar.getAttribute('data-delay') || '5', 10) * 1000;
      function show(n) {
        msgs[i].classList.remove('is-on');
        i = (n + msgs.length) % msgs.length;
        msgs[i].classList.add('is-on');
      }
      function start() { stop(); timer = setInterval(function () { show(i + 1); }, delay); }
      function stop() { if (timer) clearInterval(timer); }
      var p = $('[data-lc-top-prev]', bar), n = $('[data-lc-top-next]', bar);
      if (p) p.addEventListener('click', function () { show(i - 1); start(); });
      if (n) n.addEventListener('click', function () { show(i + 1); start(); });
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ---------------- Header: stuck state, mega menu, drawer, search ---------------- */
  function initHeader(scope) {
    var hd = $('[data-lc-header]', scope);
    if (!hd || !once(hd, 'hd')) return;

    // stuck state once the top bar has scrolled away
    var top = $('.lc-top');
    function onScroll() {
      var limit = top ? top.offsetHeight : 0;
      hd.classList.toggle('is-stuck', window.scrollY > limit + 2);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var setH = function () { root.style.setProperty('--lc-header-h', hd.offsetHeight + 'px'); };
    setH(); window.addEventListener('resize', setH);

    // mega menu with hover intent
    $$('[data-lc-mega]', hd).forEach(function (item) {
      var btn = $('.lc-hd__link', item), t = null;
      function open() { clearTimeout(t); item.classList.add('is-open'); if (btn) btn.setAttribute('aria-expanded', 'true'); }
      function close() { clearTimeout(t); t = setTimeout(function () { item.classList.remove('is-open'); if (btn) btn.setAttribute('aria-expanded', 'false'); }, 160); }
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      if (btn) btn.addEventListener('click', function (e) {
        if (btn.tagName === 'BUTTON') { e.preventDefault(); item.classList.contains('is-open') ? close() : open(); }
      });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { item.classList.remove('is-open'); } });
    });
  }

  function makeDialog(el, openAttr) {
    if (!el || !once(el, 'dlg')) return null;
    var last = null;
    function open() {
      last = doc.activeElement;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); lockScroll(true);
      var f = $('[data-lc-autofocus]', el) || $('button, a, input', el);
      if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
    function close() {
      el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); lockScroll(false);
      if (last && last.focus) try { last.focus({ preventScroll: true }); } catch (e) {}
    }
    $$('[data-lc-close]', el).forEach(function (b) { b.addEventListener('click', close); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
    doc.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[' + openAttr + ']');
      if (t) { e.preventDefault(); open(); }
    });
    return { open: open, close: close };
  }

  function initDrawer() { makeDialog($('#lc-drawer'), 'data-lc-open-drawer'); }

  function initSearch() {
    var el = $('#lc-search');
    var dlg = makeDialog(el, 'data-lc-open-search');
    if (!el || !dlg) return;
    var input = $('input[type="search"]', el), out = $('[data-lc-search-out]', el);
    var defaultHTML = out ? out.innerHTML : '', timer = null, ctrl = null;
    if (!input || !out) return;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (!q) { out.innerHTML = defaultHTML; return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { out.innerHTML = '<p class="lc-search__empty">Nothing found for &ldquo;' + esc(q) + '&rdquo;.</p>'; return; }
            out.innerHTML = '<p class="lc-search__label">Products</p><div class="lc-search__grid">' + items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<div class="lc-mcard__img"><img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy"></div>' : '';
              return '<a class="lc-mcard" href="' + p.url + '">' + img + '<div class="lc-mcard__row"><span class="lc-mcard__t">' + esc(String(p.title).replace(/N&N/g, 'Oxa')) + '</span><span class="lc-mcard__p">' + money(parseFloat(p.price) * 100) + '</span></div></a>';
            }).join('') + '</div><a class="lc-btn lc-btn--outline lc-btn--sm lc-search__all" href="/search?q=' + encodeURIComponent(q) + '&type=product">See all results</a>';
          }).catch(function () {});
      }, 180);
    });
  }

  /* ---------------- Sliders ---------------- */
  function initSliders(scope) {
    $$('[data-lc-slider]', scope).forEach(function (s) {
      if (!once(s, 'sl')) return;
      var track = $('[data-lc-track]', s);
      var prev = $('[data-lc-prev]', s), next = $('[data-lc-next]', s);
      if (!track) return;
      function step() {
        var first = track.children[0];
        if (!first) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
        return first.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------- Reveal ---------------- */
  var revealIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }) : null;
  function initReveal(scope) {
    $$('.lc-reveal', scope).forEach(function (el) {
      if (!once(el, 'rv')) return;
      if (revealIO && !reduce) revealIO.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------------- Scroll spy ---------------- */
  function initSpy(scope) {
    $$('[data-lc-spy]', scope).forEach(function (nav) {
      if (!once(nav, 'spy')) return;
      var links = $$('a[href^="#"]', nav);
      var targets = links.map(function (a) { return doc.getElementById(a.getAttribute('href').slice(1)); });
      var showAfter = doc.getElementById(nav.getAttribute('data-show-after') || '') || doc.querySelector('.lc-pm') || null;
      function onScroll() {
        var y = window.scrollY, vh = window.innerHeight;
        var visible = showAfter ? (showAfter.getBoundingClientRect().bottom < vh * 0.35) : y > 400;
        var endEl = doc.querySelector('.lc-assure-sec, .lc-ft');
        if (endEl && endEl.getBoundingClientRect().top < vh * 0.6) visible = false;
        nav.classList.toggle('is-on', visible);
        var active = -1, best = -Infinity;
        targets.forEach(function (t, i) { if (!t) return; var top = t.getBoundingClientRect().top; if (top < vh * 0.45 && top > best) { best = top; active = i; } });
        links.forEach(function (a, i) { a.classList.toggle('is-on', i === active); });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      var up = $('[data-lc-spy-top]', nav);
      if (up) up.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });
    });
  }

  /* ---------------- Statements over sticky media ---------------- */
  function initStatements(scope) {
    $$('[data-lc-stm]', scope).forEach(function (sec) {
      if (!once(sec, 'stm')) return;
      var lines = $$('.lc-stm__line', sec);
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.target.classList.toggle('is-on', e.isIntersecting); });
        }, { rootMargin: '-38% 0px -38% 0px' });
        lines.forEach(function (l) { io.observe(l); });
      } else { lines.forEach(function (l) { l.classList.add('is-on'); }); }
      var v = $('video', sec), b = $('[data-lc-stm-pause]', sec);
      function load() {
        if (!v || v.__loaded) return; v.__loaded = true;
        var d = v.getAttribute('data-lc-src'), m = v.getAttribute('data-lc-src-m') || d;
        if (d) { v.src = window.matchMedia('(min-width: 990px)').matches ? d : m; }
      }
      if (v && 'IntersectionObserver' in window) {
        var near = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { load(); near.disconnect(); } }); }, { rootMargin: '600px 0px' });
        near.observe(sec);
      } else load();
      if (v) {
        if (reduce) { try { v.pause(); } catch (e) {} }
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (en) {
            en.forEach(function (x) { if (!x.isIntersecting) { try { v.pause(); } catch (e) {} } else if (!sec.__paused && !reduce) { load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
          }).observe(sec);
        }
        if (b) b.addEventListener('click', function () {
          if (v.paused) { sec.__paused = false; v.play(); b.innerHTML = b.getAttribute('data-pause-ico'); b.setAttribute('aria-label', 'Pause video'); }
          else { sec.__paused = true; v.pause(); b.innerHTML = b.getAttribute('data-play-ico'); b.setAttribute('aria-label', 'Play video'); }
        });
      }
    });
  }

  /* ---------------- Product page ---------------- */
  function initProduct(scope) {
    $$('[data-lc-product]', scope).forEach(function (pm) {
      if (!once(pm, 'pm')) return;
      var sid = pm.getAttribute('data-section');
      var stage = $('.lc-gal__stage', pm);
      var thumbs = $$('.lc-gal__thumb', pm);
      var items = stage ? $$('.lc-gal__stage-item', stage) : [];
      var rail = $('.lc-gal__rail', pm);
      var dots = $$('.lc-gal__dots button', pm);
      var mobile = window.matchMedia('(max-width: 989px)');

      function setStage(i) {
        if (!items.length) return;
        items.forEach(function (it, n) {
          var on = n === i;
          it.classList.toggle('is-on', on);
          var vid = $('video', it);
          if (vid) { if (on) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else { try { vid.pause(); } catch (e) {} } }
        });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        pm.__active = i;
      }
      thumbs.forEach(function (t, n) {
        t.addEventListener('click', function () {
          if (mobile.matches) { openLightbox(n); return; }
          setStage(n);
        });
      });
      var zoom = $('[data-lc-zoom]', pm);
      if (zoom) zoom.addEventListener('click', function () { openLightbox(pm.__active || 0); });

      // mobile dots follow the rail scroll
      if (rail && dots.length) {
        rail.addEventListener('scroll', function () {
          var w = rail.children[0] ? rail.children[0].getBoundingClientRect().width + 10 : rail.clientWidth;
          var i = Math.round(rail.scrollLeft / w);
          dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        }, { passive: true });
        dots.forEach(function (d, n) {
          d.addEventListener('click', function () {
            var w = rail.children[0] ? rail.children[0].getBoundingClientRect().width + 10 : rail.clientWidth;
            rail.scrollTo({ left: w * n, behavior: 'smooth' });
          });
        });
      }

      // arrows: one image per click, wrapping round at either end
      var prevB = $('[data-lc-gal-prev]', pm), nextB = $('[data-lc-gal-next]', pm);
      if (rail && (prevB || nextB)) {
        var goSlide = function (d) {
          var n = rail.children.length; if (n < 2) return;
          var w = rail.children[0].getBoundingClientRect().width + 10;
          var i = Math.round(rail.scrollLeft / w);
          rail.scrollTo({ left: w * ((i + d + n) % n), behavior: 'smooth' });
        };
        if (prevB) prevB.addEventListener('click', function () { goSlide(-1); });
        if (nextB) nextB.addEventListener('click', function () { goSlide(1); });
      }

      // lightbox built from the thumbs' data
      var lb = null, lbIndex = 0;
      function lbRender() {
        var t = thumbs[lbIndex]; if (!t) return;
        var holder = $('[data-lc-lb-media]', lb);
        var vsrc = t.getAttribute('data-video');
        if (vsrc) holder.innerHTML = '<video src="' + vsrc + '" controls autoplay playsinline></video>';
        else holder.innerHTML = '<img src="' + t.getAttribute('data-full') + '" alt="' + esc(t.getAttribute('data-alt') || '') + '">';
      }
      function openLightbox(i) {
        if (!thumbs.length) return;
        if (!lb) {
          lb = doc.createElement('div');
          lb.className = 'lc lc-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product media');
          lb.innerHTML = '<div data-lc-lb-media></div>' +
            '<button type="button" class="lc-lb__x" aria-label="Close">' + ico('close') + '</button>' +
            (thumbs.length > 1 ? '<button type="button" class="lc-lb__nav lc-lb__nav--p" aria-label="Previous">' + ico('arrow-left') + '</button><button type="button" class="lc-lb__nav lc-lb__nav--n" aria-label="Next">' + ico('arrow-right') + '</button>' : '');
          doc.body.appendChild(lb);
          lb.addEventListener('click', function (e) {
            if (e.target === lb || e.target.closest('.lc-lb__x')) closeLb();
            else if (e.target.closest('.lc-lb__nav--p')) { lbIndex = (lbIndex - 1 + thumbs.length) % thumbs.length; lbRender(); }
            else if (e.target.closest('.lc-lb__nav--n')) { lbIndex = (lbIndex + 1) % thumbs.length; lbRender(); }
          });
          doc.addEventListener('keydown', function (e) {
            if (!lb.classList.contains('is-open')) return;
            if (e.key === 'Escape') closeLb();
            if (e.key === 'ArrowLeft' && thumbs.length > 1) { lbIndex = (lbIndex - 1 + thumbs.length) % thumbs.length; lbRender(); }
            if (e.key === 'ArrowRight' && thumbs.length > 1) { lbIndex = (lbIndex + 1) % thumbs.length; lbRender(); }
          });
        }
        lbIndex = i; lbRender(); lb.classList.add('is-open'); lockScroll(true);
      }
      function closeLb() { lb.classList.remove('is-open'); lockScroll(false); var h = $('[data-lc-lb-media]', lb); if (h) h.innerHTML = ''; }

      // quantity stepper (only on products without the bundle picker)
      var qtyInput = $('.mvx-hp__qty', pm);
      $$('[data-lc-qty]', pm).forEach(function (b) {
        b.addEventListener('click', function () {
          var field = $('.lc-qty input', pm); if (!field) return;
          var v = Math.max(1, (parseInt(field.value, 10) || 1) + parseInt(b.getAttribute('data-lc-qty'), 10));
          field.value = v; if (qtyInput) qtyInput.value = v;
        });
      });
      var qField = $('.lc-qty input', pm);
      if (qField) qField.addEventListener('change', function () { var v = Math.max(1, parseInt(qField.value, 10) || 1); qField.value = v; if (qtyInput) qtyInput.value = v; });

      // variant buttons (products with more than one variant)
      var variants = null;
      try { variants = JSON.parse(($('[data-lc-variants]', pm) || {}).textContent || 'null'); } catch (e) {}
      if (variants && variants.length > 1) {
        var idInput = $('input[name="id"]', pm);
        $$('.lc-opt__val', pm).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var group = btn.closest('.lc-opt');
            $$('.lc-opt__val', group).forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true');
            var lbl = $('.lc-opt__label strong', group); if (lbl) lbl.textContent = btn.getAttribute('data-value');
            var chosen = $$('.lc-opt', pm).map(function (g) { var on = $('.lc-opt__val.is-on', g); return on ? on.getAttribute('data-value') : null; });
            var match = variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
            if (!match) return;
            if (idInput) idInput.value = match.id;
            var now = $('.mvx-hp__now', pm), was = $('.mvx-hp__was', pm);
            if (now) now.textContent = money(match.price);
            if (was) { if (match.compare_at_price > match.price) { was.textContent = money(match.compare_at_price); was.hidden = false; } else { was.hidden = true; } }
            var atc = $('.lc-pm__atc', pm);
            if (atc) { atc.disabled = !match.available; var l = $('[data-lc-atc-label]', atc); if (l) l.textContent = match.available ? (atc.getAttribute('data-label') || 'Add to cart') : 'Sold out'; }
            if (match.featured_media_index != null && match.featured_media_index > -1) setStage(match.featured_media_index);
            try { var u = new URL(location.href); u.searchParams.set('variant', match.id); history.replaceState({}, '', u); } catch (e) {}
            syncPrice();
          });
        });
      }

      // keep the button price and sticky bar in step with the bundle picker
      var nowEl = $('.mvx-hp__now', pm);
      var atcPrice = $('[data-lc-atc-price]', pm);
      var sticky = $('[data-lc-sticky]', pm) || doc.querySelector('[data-lc-sticky="' + sid + '"]');
      var stickyPrice = sticky ? $('[data-lc-sticky-price]', sticky) : null;
      var stickySub = sticky ? $('[data-lc-sticky-sub]', sticky) : null;
      var saveEl = $('[data-lc-save]', pm), wasEl = $('.mvx-hp__was', pm);
      function num(t) { return parseFloat(String(t).replace(/[^0-9.]/g, '')) || 0; }
      function syncPrice() {
        if (!nowEl) return;
        var txt = nowEl.textContent.trim();
        if (saveEl && wasEl) {
          var w = num(wasEl.textContent), n = num(txt);
          if (wasEl.style.display !== 'none' && !wasEl.hidden && w > n) { saveEl.textContent = 'Save ' + Math.round((w - n) / w * 100) + '%'; saveEl.hidden = false; }
          else saveEl.hidden = true;
        }
        if (atcPrice) atcPrice.textContent = txt;
        if (stickyPrice) stickyPrice.textContent = txt;
        var on = $('.mvx-bn.is-on .mvx-bn__name', pm);
        if (stickySub && on) stickySub.textContent = on.textContent.trim();
      }
      if (nowEl && 'MutationObserver' in window) new MutationObserver(syncPrice).observe(nowEl, { childList: true, characterData: true, subtree: true });
      syncPrice();

      // Buy it now: add with the chosen quantity, then straight to checkout
      var buyNow = $('[data-lc-buynow]', pm);
      var form = $('form.mvx-hp__form', pm);
      if (buyNow && form) buyNow.addEventListener('click', function () {
        buyNow.disabled = true;
        fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/checkout'; })
          .catch(function () { buyNow.disabled = false; form.submit(); });
      });

      // sticky add to cart: shown once the real button is off screen
      var buyRow = $('.lc-pm__buy', pm);
      if (sticky && buyRow && 'IntersectionObserver' in window) {
        var footerSeen = false, rowGone = false;
        function paint() { var on = rowGone && !footerSeen; sticky.classList.toggle('is-on', on); doc.body.classList.toggle('lc-sticky-on', on); }
        new IntersectionObserver(function (en) { en.forEach(function (x) { rowGone = !x.isIntersecting && x.boundingClientRect.top < 0; paint(); }); }).observe(buyRow);
        var ft = doc.querySelector('.lc-ft');
        if (ft) new IntersectionObserver(function (en) { en.forEach(function (x) { footerSeen = x.isIntersecting; paint(); }); }).observe(ft);
        var sBtn = $('[data-lc-sticky-add]', sticky);
        if (sBtn) sBtn.addEventListener('click', function () { var real = $('.lc-pm__atc', pm); if (real) real.click(); });
      }

      // share: copy link
      $$('[data-lc-copy]', pm).forEach(function (b) {
        b.addEventListener('click', function () {
          var url = b.getAttribute('data-lc-copy') || location.href;
          var done = function () { var n = $('.lc-pm__copied', pm); if (n) { n.classList.add('is-on'); setTimeout(function () { n.classList.remove('is-on'); }, 1600); } };
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done); else done();
        });
      });
    });
  }

  function ico(name) {
    var p = {
      'close': '<path d="M6 6l12 12M18 6L6 18"/>',
      'arrow-left': '<path d="M20 12H4M10 6l-6 6 6 6"/>',
      'arrow-right': '<path d="M4 12h16M14 6l6 6-6 6"/>',
      'minus': '<path d="M5 12h14"/>',
      'plus': '<path d="M12 5v14M5 12h14"/>',
      'bag': '<path d="M5 8h14l-1 12.2a1 1 0 01-1 .8H7a1 1 0 01-1-.8z"/><path d="M9 8V6.5a3 3 0 016 0V8"/>'
    }[name] || '';
    return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + '</svg>';
  }

  /* ---------------- Cart drawer ---------------- */
  function initCart() {
    var cd = $('#lc-cd');
    if (!cd || !once(cd, 'cd')) return;
    var body = $('[data-lc-cd-body]', cd), foot = $('[data-lc-cd-foot]', cd), ship = $('[data-lc-cd-ship]', cd);
    var nEl = $('[data-lc-cd-n]', cd), subEl = $('[data-lc-cd-sub]', cd), totEl = $('[data-lc-cd-total]', cd);
    var discRow = $('[data-lc-cd-disc]', cd), discLbl = $('[data-lc-cd-disc-label]', cd), discAmt = $('[data-lc-cd-disc-amt]', cd);
    var emptyHTML = ($('template[data-lc-cd-empty]', cd) || {}).innerHTML || '';
    var busy = false, last = null;

    function open() { last = doc.activeElement; cd.classList.add('is-open'); cd.setAttribute('aria-hidden', 'false'); lockScroll(true); var x = $('[data-lc-close]', cd); if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 80); }
    function close() { cd.classList.remove('is-open'); cd.setAttribute('aria-hidden', 'true'); lockScroll(false); if (last && last.focus) try { last.focus({ preventScroll: true }); } catch (e) {} }
    $$('[data-lc-close]', cd).forEach(function (b) { b.addEventListener('click', close); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cd.classList.contains('is-open')) close(); });

    function badge(n) {
      $$('[data-lc-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !(n > 0); });
    }
    function render(cart) {
      var has = cart.items && cart.items.length;
      if (nEl) nEl.textContent = cart.item_count || 0;
      if (foot) foot.hidden = !has;
      if (ship) ship.hidden = !has;
      if (!has) { body.innerHTML = emptyHTML; }
      else {
        body.innerHTML = cart.items.map(function (i) {
          var img = i.image ? '<img src="' + i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '';
          var variant = (i.variant_title && i.variant_title !== 'Default Title') ? '<p class="lc-cd__v">' + esc(i.variant_title) + '</p>' : '';
          var line = i.final_line_price != null ? i.final_line_price : i.line_price;
          var orig = i.original_line_price != null && i.original_line_price > line ? '<s>' + money(i.original_line_price) + '</s>' : '';
          return '<div class="lc-cd__li">' +
            '<a class="lc-cd__img" href="' + i.url + '">' + img + '</a>' +
            '<div><a class="lc-cd__t" href="' + i.url + '">' + esc(String(i.product_title).replace(/N&N/g, 'Oxa')) + '</a>' + variant +
              '<div class="lc-cd__ctrl"><span class="lc-cd__qty">' +
                '<button type="button" data-lc-q="' + esc(i.key) + '" data-to="' + (i.quantity - 1) + '" aria-label="Decrease quantity">' + ico('minus') + '</button>' +
                '<span>' + i.quantity + '</span>' +
                '<button type="button" data-lc-q="' + esc(i.key) + '" data-to="' + (i.quantity + 1) + '" aria-label="Increase quantity">' + ico('plus') + '</button>' +
              '</span><button type="button" class="lc-cd__rm" data-lc-q="' + esc(i.key) + '" data-to="0">Remove</button></div></div>' +
            '<div class="lc-cd__p">' + orig + money(line) + '</div></div>';
        }).join('');
      }
      var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : (cart.original_total_price || 0);
      if (subEl) subEl.textContent = money(sub);
      if (totEl) totEl.textContent = money(cart.total_price || 0);
      var apps = cart.cart_level_discount_applications || [];
      var saved = cart.total_discount || 0;
      if (discRow) {
        if (saved > 0) {
          discRow.hidden = false;
          if (discLbl) discLbl.textContent = apps.length ? (apps[0].title || apps[0].code || 'Saving') : 'Saving';
          if (discAmt) discAmt.textContent = '-' + money(saved);
        } else discRow.hidden = true;
      }
      badge(cart.item_count || 0);
    }
    function refresh() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
    }
    function change(key, qty) {
      if (busy) return; busy = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(render).catch(refresh)
        .then(function () { busy = false; }, function () { busy = false; });
    }
    doc.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-lc-q]');
      if (q && cd.contains(q)) { e.preventDefault(); change(q.getAttribute('data-lc-q'), parseInt(q.getAttribute('data-to'), 10)); return; }
      var link = e.target.closest && e.target.closest('[data-lc-open-cart]');
      if (link) { e.preventDefault(); refresh().then(open); }
    });
    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]') || e.submitter;
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = '<span>Adding…</span>'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(refresh).then(open)
        .catch(function () { location.href = '/cart'; })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } }, function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
    });
    window.LCcart = { open: function () { refresh().then(open); }, refresh: refresh };
    refresh();
  }


  /* ---------------- Fade carousels (hero slideshow, testimonials) ---------------- */
  function initSlideshows(scope) {
    $$('[data-lc-ss]', scope).forEach(function (ss) {
      if (!once(ss, 'ss')) return;
      var slides = $$('.lc-ss__slide', ss), dots = $$('[data-lc-ss-dot]', ss);
      var i = 0, t = null, delay = (parseInt(ss.getAttribute('data-delay') || '6', 10)) * 1000;
      function loadVid(sl) { var v = $('video[data-lc-src]', sl); if (v && !v.src) { v.src = v.getAttribute('data-lc-src'); } return v; }
      function go(n) {
        if (!slides.length) return;
        var prev = slides[i]; i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        var pv = $('video', prev); if (pv && prev !== slides[i]) { try { pv.pause(); } catch (e) {} }
        var v = loadVid(slides[i]); if (v && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      }
      function start() { stop(); if (slides.length > 1 && !reduce) t = setInterval(function () { go(i + 1); }, delay); }
      function stop() { if (t) clearInterval(t); }
      var pb = $('[data-lc-ss-prev]', ss), nb = $('[data-lc-ss-next]', ss);
      if (pb) pb.addEventListener('click', function () { go(i - 1); start(); });
      if (nb) nb.addEventListener('click', function () { go(i + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-lc-ss-dot'), 10)); start(); }); });
      ss.addEventListener('mouseenter', stop); ss.addEventListener('mouseleave', start);
      // swipe
      var x0 = null;
      ss.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      ss.addEventListener('touchend', function (e) { if (x0 == null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); start(); } x0 = null; });
      var first = loadVid(slides[0]); if (first && !reduce) { var p = first.play(); if (p && p.catch) p.catch(function () {}); }
      start();
    });
  }

  /* ---------------- Lazy background videos (banners) ---------------- */
  function initBanners(scope) {
    $$('[data-lc-bn]', scope).forEach(function (bn) {
      if (!once(bn, 'bn')) return;
      var v = $('video[data-lc-src]', bn); if (!v) return;
      if (!('IntersectionObserver' in window)) { v.src = v.getAttribute('data-lc-src'); return; }
      new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (x.isIntersecting) {
            if (!v.src) v.src = window.matchMedia('(min-width: 990px)').matches ? v.getAttribute('data-lc-src') : (v.getAttribute('data-lc-src-m') || v.getAttribute('data-lc-src'));
            if (!reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else { try { v.pause(); } catch (e) {} }
        });
      }, { rootMargin: '300px 0px' }).observe(bn);
    });
  }

  /* ---------------- Compare slider ---------------- */
  function initCompare(scope) {
    $$('[data-lc-cmp]', scope).forEach(function (c) {
      if (!once(c, 'cmp')) return;
      var r = $('[data-lc-cmp-range]', c);
      if (r) r.addEventListener('input', function () { c.style.setProperty('--lc-pos', r.value + '%'); });
    });
  }

  /* ---------------- Shop the look ---------------- */
  function initLook(scope) {
    $$('[data-lc-look]', scope).forEach(function (lk) {
      if (!once(lk, 'look')) return;
      var spots = $$('[data-lc-look-spot]', lk), cards = $$('[data-lc-look-card]', lk);
      spots.forEach(function (s) {
        s.addEventListener('click', function () {
          var n = s.getAttribute('data-lc-look-spot');
          spots.forEach(function (x) { x.classList.toggle('is-on', x === s); });
          cards.forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-lc-look-card') === n); });
        });
      });
    });
  }


  /* ---------------- Collection: filters + sort ---------------- */
  function initCollection(scope) {
    $$('[data-lc-coll]', scope).forEach(function (c) {
      if (!once(c, 'coll')) return;
      var layout = $('[data-lc-coll-layout]', c), btn = $('[data-lc-filter-toggle]', c);
      var label = btn ? $('[data-lc-filter-label]', btn) : null, form = $('[data-lc-filter-form]', c);
      var desk = window.matchMedia('(min-width: 990px)');
      function set(open) {
        if (!layout) return;
        layout.classList.toggle('is-open', open);
        if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (label) label.textContent = open ? label.getAttribute('data-hide') : label.getAttribute('data-show');
        if (!desk.matches) lockScroll(open);
        root.classList.toggle('lc-raise-main', open && !desk.matches);
      }
      if (layout && layout.hasAttribute('data-open-desktop') && desk.matches) set(true);
      if (btn) btn.addEventListener('click', function () { set(!layout.classList.contains('is-open')); });
      $$('[data-lc-filter-close]', c).forEach(function (x) { x.addEventListener('click', function () { set(false); }); });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && layout && layout.classList.contains('is-open') && !desk.matches) set(false); });
      desk.addEventListener && desk.addEventListener('change', function () { lockScroll(false); root.classList.remove('lc-raise-main'); });
      if (form) {
        // Desktop applies each tick straight away; the drawer on phones waits for "Show results".
        form.addEventListener('change', function (e) {
          if (!desk.matches) return;
          if (e.target && e.target.type === 'number') return;
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
        form.addEventListener('submit', function () {
          $$('input[type=number]', form).forEach(function (i) { if (i.value === '') i.disabled = true; });
        });
      }
      var sort = $('[data-lc-sort]', c);
      if (sort) sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    });
  }

  /* ---------------- Cart page ---------------- */
  function initCartPage(scope) {
    $$('[data-lc-cartp-form]', scope).forEach(function (form) {
      if (!once(form, 'cartp')) return;
      var wrap = form.closest('[data-lc-cartp]'), timer;
      function update() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (wrap) wrap.classList.add('is-busy');
          var h = doc.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = '1';
          form.appendChild(h);
          form.submit();
        }, 450);
      }
      $$('[data-lc-cartp-qty]', form).forEach(function (q) {
        var input = $('input', q);
        $$('button[data-step]', q).forEach(function (b) {
          b.addEventListener('click', function () {
            var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
            input.value = v; update();
          });
        });
        input.addEventListener('change', update);
      });
    });
  }

  /* ---------------- Boot ---------------- */
  function init(scope) {
    initTopbar(scope); initHeader(scope); initSliders(scope); initReveal(scope);
    initSpy(scope); initStatements(scope); initProduct(scope);
    initSlideshows(scope); initBanners(scope); initCompare(scope); initLook(scope);
    initCollection(scope); initCartPage(scope);
  }
  function boot() { init(doc); initDrawer(); initSearch(); initCart(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
